<template>
  <div>
    <span>{{ counts }}</span>
  </div>
</template>

<script>
export default {
  name: 'TaskFileInfoCounts',
  components: { },
  props: {
    row: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    }
  },
  computed: {
    counts: function () {
      return this.row[this.prop] > 0 ? this.row[this.prop] + ' 条' : ' 条'
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/upload_tasks/common/TaskFileInfoCounts.vue